/* eslint-disable indent */
import i18n from './reacti18n';
import { getQueryValue } from './location-helper';
import Page from './page';

/**
 * Tcode mappings for AUP Violation webform from RC - RC Key Names
 */
// L1 level selection - RC key name
const L1_PAYPAL_ME_LINK = 'L1PaypalMeLink';
const L1_GENEROSITY_NETWORK_CAMPAIGN = 'L1GenerosityNetworkCampaign';
const L1_OFFENSIVE_OR_GRAPHIC_IMAGE = 'L1OffensiveOrGraphicImage';
const L1_VENMO_PROFILE = 'L1VenmoProfile';
const L1_OTHER_VIOLATION_OF_POLICY = 'L1OtherViolationOfPolicy';

// L2 level selection - RC key name
const L2_MATURE_ADULT_CONTENT = 'L2MatureAdultContent';
const L2_CHILD_EXPLOITATION = 'L2ChildExploitation';
const L2_HATE_VIOLENCE_RACIAL_OTHER_INTOLERANCE = 'L2HateViolenceRacialOtherIntolerance';
const L2_COUNTERFEIT_OR_STOLEN_GOODS = 'L2CounterfeitOrStolenGoods';
const L2_FIRE_ARMS_AND_WEAPONS = 'L2FirearmsAndWeapons';
const L2_GAMBLING = 'L2Gambling';
const L2_MULTILEVEL_MARKETING_AND_PONZI_SCHEMES = 'L2MultilevelMarketingAndPonziSchemes';
const L2_PRESCRIPTION_DRUGS = 'L2PrescriptionDrugs';
const L2_ILLEGAL_NARCOTICS = 'L2IllegalNarcotics';
const L2_COPYRIGHT_OR_TRADE_INFRINGEMENT = 'L2CopyrightOrTradeInfringement';

/**
 * Tcode mappings for AUP Violation webform from Remote config
 */
const aupViolationTcodeConfig = Page.getAupViolationTcodeConfig();

const paypalForm = {
  textField: {
    additional: i18n.message('smarthelp/paypalmeForm.paypalform.textField.additional'),
    firstName: i18n.message('smarthelp/paypalmeForm.paypalform.textField.firstName'),
    lastName: i18n.message('smarthelp/paypalmeForm.paypalform.textField.lastName'),
    email: i18n.message('smarthelp/paypalmeForm.paypalform.textField.email'),
  },
  violdation: {
    header: i18n.message('smarthelp/paypalmeForm.paypalform.violdation.header'),
    announcement: i18n.message('smarthelp/paypalmeForm.paypalform.violdation.announcement'),
  },
  report: {
    header: i18n.message('smarthelp/paypalmeForm.paypalform.report.header'),
    body: i18n.message('smarthelp/paypalmeForm.paypalform.report.body'),
    newBody: i18n.message('smarthelp/paypalmeForm.paypalform.report.newBody'),
    continue: i18n.message('smarthelp/paypalmeForm.paypalform.report.continue'),
    nextHeader: i18n.message('smarthelp/paypalmeForm.paypalform.report.nextHeader'),
    contentReview: i18n.message('smarthelp/paypalmeForm.paypalform.report.contentReview'),
    contentDetail: i18n.message('smarthelp/paypalmeForm.paypalform.report.contentDetail'),
  },
  selection: {
    header: i18n.message('smarthelp/paypalmeForm.paypalform.selection.header'),
    default: i18n.message('smarthelp/paypalmeForm.paypalform.selection.default'),
    textField: {
      paypalme: i18n.message('smarthelp/paypalmeForm.paypalform.selection.textField.paypalme'),
      transaction: i18n.message('smarthelp/paypalmeForm.paypalform.selection.textField.transaction'),
      transactionEmail: i18n.message('smarthelp/paypalmeForm.paypalform.selection.textField.transactionEmail'),
      generosityNetworkUrl: i18n.message('smarthelp/paypalmeForm.paypalform.selection.textField.generosityNetworkUrl'),
    },
    L2: {
      placeHolder: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L2.placeHolder'),
      options: {
        mature: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L2.options.mature'),
        child: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L2.options.child'),
        intolerance: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L2.options.intolerance'),
        counterfeit: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L2.options.counterfeit'),
        firearms: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L2.options.firearms'),
        gambling: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L2.options.gambling'),
        marketing: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L2.options.marketing'),
        drugs: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L2.options.drugs'),
        illegal: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L2.options.illegal'),
        copyright: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L2.options.copyright'),
      },
    },
    L1: {
      placeHolder: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L1.placeHolder'),
      options: {
        offensive: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L1.options.offensive'),
        paypalme: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L1.options.paypalme'),
        generosityNetwork: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L1.options.generosityNetwork'),
        venmoProfile: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L1.options.venmoProfile'),
        others: i18n.message('smarthelp/paypalmeForm.paypalform.selection.L1.options.others'),
      },
    },
  },
};

const ipInfringementForm = {
  introLabel: i18n.message('smarthelp/emailUs.emailUs.infringement.introLabel'),
  introDescription1: i18n.message('smarthelp/emailUs.emailUs.infringement.introDescription1'),
  introDescription2: i18n.message('smarthelp/emailUs.emailUs.infringement.introDescription2'),
  introText: i18n.message('smarthelp/emailUs.emailUs.infringement.introText'),
  type: i18n.message('smarthelp/emailUs.emailUs.infringement.type'),
  type1: i18n.message('smarthelp/emailUs.emailUs.infringement.type1'),
  type2: i18n.message('smarthelp/emailUs.emailUs.infringement.type2'),
  filerType: i18n.message('smarthelp/emailUs.emailUs.infringement.filerType'),
  filerType1: i18n.message('smarthelp/emailUs.emailUs.infringement.filerType1'),
  filerType2: i18n.message('smarthelp/emailUs.emailUs.infringement.filerType2'),
  businessInfo: i18n.message('smarthelp/emailUs.emailUs.infringement.businessInfo'),
  jobTitle: i18n.message('smarthelp/emailUs.emailUs.infringement.jobTitle'),
  companyName: i18n.message('smarthelp/emailUs.emailUs.infringement.companyName'),
  address: i18n.message('smarthelp/emailUs.emailUs.infringement.address'),
  city: i18n.message('smarthelp/emailUs.emailUs.infringement.city'),
  state: i18n.message('smarthelp/emailUs.emailUs.infringement.state'),
  postalCode: i18n.message('smarthelp/emailUs.emailUs.infringement.postalCode'),
  country: i18n.message('smarthelp/emailUs.emailUs.infringement.country'),
  telephone: i18n.message('smarthelp/emailUs.emailUs.infringement.telephone'),
  tradeMarkInfo: i18n.message('smarthelp/emailUs.emailUs.infringement.tradeMarkInfo'),
  tradeMarkDescription: i18n.message('smarthelp/emailUs.emailUs.infringement.tradeMarkDescription'),
  copyRightInfo: i18n.message('smarthelp/emailUs.emailUs.infringement.copyRightInfo'),
  copyRightDescription: i18n.message('smarthelp/emailUs.emailUs.infringement.copyRightDescription'),
  locationLabel: i18n.message('smarthelp/emailUs.emailUs.infringement.locationLabel'),
  registration: i18n.message('smarthelp/emailUs.emailUs.infringement.registration'),
  rights: i18n.message('smarthelp/emailUs.emailUs.infringement.rights'),
  urlDescription: i18n.message('smarthelp/emailUs.emailUs.infringement.urlDescription'),
  paymentLabel: i18n.message('smarthelp/emailUs.emailUs.infringement.paymentLabel'),
  paymentDescription: i18n.message('smarthelp/emailUs.emailUs.infringement.paymentDescription'),
  merchantDetails: i18n.message('smarthelp/emailUs.emailUs.infringement.merchantDetails'),
  contactLabel: i18n.message('smarthelp/emailUs.emailUs.infringement.contactLabel'),
  firstName: i18n.message('smarthelp/emailUs.emailUs.infringement.firstName'),
  lastName: i18n.message('smarthelp/emailUs.emailUs.infringement.lastName'),
  email: i18n.message('smarthelp/emailUs.emailUs.infringement.email'),
};

// <------------- Dynamic loading fields --------------->

// if venmo query is available in url, then auto select venmo profile
export const selectDefaultViolation = () => {
  const venmoQuery = getQueryValue('reqFromVenmo', window.location);
  if (venmoQuery === 'true') {
    return paypalForm.selection.L1.options.venmoProfile;
  }
  return '';
};

export const selectViolationPartial = () => ({
  id: 'select_violation_type_partial',
  ref_id: 'select_violation_type_all',
  required: true,
  type: 'select',
  options: [
    paypalForm.selection.default,
    paypalForm.selection.L2.options.mature,
    paypalForm.selection.L2.options.child,
    paypalForm.selection.L2.options.intolerance,
  ],
  depends_on_id: 'select_violation',
  depends_on_value: [paypalForm.selection.L1.options.offensive],
});

export const selectViolationTypeAll = () => ({
  id: 'select_violation_type_all',
  required: true,
  type: 'select',
  options: [
    paypalForm.selection.default,
    paypalForm.selection.L2.options.mature,
    paypalForm.selection.L2.options.child,
    paypalForm.selection.L2.options.intolerance,
    paypalForm.selection.L2.options.counterfeit,
    paypalForm.selection.L2.options.firearms,
    paypalForm.selection.L2.options.gambling,
    paypalForm.selection.L2.options.marketing,
    paypalForm.selection.L2.options.drugs,
    paypalForm.selection.L2.options.illegal,
    paypalForm.selection.L2.options.copyright,
  ],
  depends_on_id: 'select_violation',
  depends_on_value: [
    paypalForm.selection.L1.options.paypalme,
    paypalForm.selection.L1.options.generosityNetwork,
    paypalForm.selection.L1.options.venmoProfile,
    paypalForm.selection.L1.options.others,
  ],
});

export const textPayPalMeLink = () => ({
  id: 'paypalme_link',
  type: 'text',
  default_text: paypalForm.selection.textField.paypalme,
  required: true,
  character_limit: '200',
  depends_on_id: 'select_violation',
  depends_on_value: [paypalForm.selection.L1.options.paypalme],
  url_validation: 'www.paypal.me',
});

export const textGenerosityNetwork = () => ({
  id: 'generosity_network',
  type: 'text',
  // placeholder for generosityNetwork / fundraiser option
  default_text: paypalForm.selection.textField.generosityNetworkUrl,
  required: true,
  character_limit: '200',
  depends_on_id: 'select_violation',
  depends_on_value: [paypalForm.selection.L1.options.generosityNetwork],
});

export const textTransactionId = () => ({
  id: 'trans_id',
  type: 'text',
  default_text: paypalForm.selection.textField.transaction,
  required: true,
  character_limit: '200',
  depends_on_id: 'select_violation',
  depends_on_value: [paypalForm.selection.L1.options.offensive],
});

export const textTransactionIdOrEmail = () => ({
  id: 'trans_id_or_email',
  type: 'text',
  default_text: paypalForm.selection.textField.transactionEmail,
  required: true,
  character_limit: '200',
  depends_on_id: 'select_violation',
  depends_on_value: [paypalForm.selection.L1.options.others],
});
// <------------- End: Dynamic loading fields --------------->

// Parse Email for for the AUP PayPal.Me webform
export const parseEmailForm = () => [
  {
    default_text: `
    <b>${paypalForm.violdation.header}</b><br>
    <br>${paypalForm.violdation.announcement}<br>
    <br><b>${paypalForm.report.header}</b><br>
    <br>${paypalForm.report.continue}<br>
    <br><b>${paypalForm.report.nextHeader}</b><br>
    <br>${paypalForm.report.contentReview}<br>
    <br>${paypalForm.report.contentDetail}<br>
    <br><b>${paypalForm.selection.header}</b><br>
    <br>${paypalForm.selection.L1.placeHolder}`,
    required: false,
    type: 'paragraph',
  },
  {
    id: 'select_violation',
    required: true,
    type: 'select',
    value: selectDefaultViolation(),
    options: [
      paypalForm.selection.default,
      paypalForm.selection.L1.options.paypalme,
      paypalForm.selection.L1.options.generosityNetwork,
      paypalForm.selection.L1.options.offensive,
      paypalForm.selection.L1.options.venmoProfile,
      paypalForm.selection.L1.options.others,
    ],
  },
  selectViolationPartial(),
  selectViolationTypeAll(),
  textPayPalMeLink(),
  textGenerosityNetwork(),
  textTransactionId(),
  textTransactionIdOrEmail(),
  {
    id: 'additional_comments',
    required: true,
    type: 'textarea',
    default_text: paypalForm.textField.additional,
    character_limit: '2500',
  },
  {
    id: 'first_name',
    type: 'text',
    default_text: paypalForm.textField.firstName,
    required: true,
    character_limit: '200',
  },
  {
    id: 'last_name',
    type: 'text',
    default_text: paypalForm.textField.lastName,
    required: true,
    character_limit: '200',
  },
  {
    id: 'email_address',
    type: 'text',
    default_text: paypalForm.textField.email,
    required: true,
    character_limit: '200',
  },
];

// Get the RC key name for L1 selection
export const getRcKeyNameForL1Selection = (primarySelection) => {
  switch (primarySelection) {
    case paypalForm.selection.L1.options.paypalme:
      return L1_PAYPAL_ME_LINK;
    case paypalForm.selection.L1.options.offensive:
      return L1_OFFENSIVE_OR_GRAPHIC_IMAGE;
    case paypalForm.selection.L1.options.generosityNetwork:
      return L1_GENEROSITY_NETWORK_CAMPAIGN;
    case paypalForm.selection.L1.options.venmoProfile:
      return L1_VENMO_PROFILE;
    case paypalForm.selection.L1.options.others:
      return L1_OTHER_VIOLATION_OF_POLICY;
    default:
      return '';
  }
};

// Get the RC key name for L2 selection
export const getRcKeyNameForL2Selection = (secondarySelection) => {
  switch (secondarySelection) {
    case paypalForm.selection.L2.options.mature:
      return L2_MATURE_ADULT_CONTENT;
    case paypalForm.selection.L2.options.child:
      return L2_CHILD_EXPLOITATION;
    case paypalForm.selection.L2.options.intolerance:
      return L2_HATE_VIOLENCE_RACIAL_OTHER_INTOLERANCE;
    case paypalForm.selection.L2.options.counterfeit:
      return L2_COUNTERFEIT_OR_STOLEN_GOODS;
    case paypalForm.selection.L2.options.firearms:
      return L2_FIRE_ARMS_AND_WEAPONS;
    case paypalForm.selection.L2.options.gambling:
      return L2_GAMBLING;
    case paypalForm.selection.L2.options.marketing:
      return L2_MULTILEVEL_MARKETING_AND_PONZI_SCHEMES;
    case paypalForm.selection.L2.options.drugs:
      return L2_PRESCRIPTION_DRUGS;
    case paypalForm.selection.L2.options.illegal:
      return L2_ILLEGAL_NARCOTICS;
    case paypalForm.selection.L2.options.copyright:
      return L2_COPYRIGHT_OR_TRADE_INFRINGEMENT;
    default:
      return '';
  }
};

// get the TCode mapping from RC
export const topicTcodeMapping = (l1Selection, l2Selection) => {
  if (l1Selection && l2Selection) {
    return aupViolationTcodeConfig[l1Selection][l2Selection];
  }

  return '';
};

/**
 * Function to parse text field
 */
const parseTextField = (id, defaultText = '') => ({
  id,
  type: 'text',
  default_text: ipInfringementForm[defaultText],
  required: true,
  character_limit: '500',
});

/**
 * Function to parse paragraph field
 */
const parseLabelField = (defaultText = '') => ({
  type: 'paragraph',
  default_text: ipInfringementForm[defaultText],
  required: false,
});

/**
 * Function to parse and return IPInfringement webform form elements
 */
export const parseIpinfringementEmailWebform = () => [
  {
    default_text: `
    <b>${ipInfringementForm.introLabel}</b><br>
    <br>${ipInfringementForm.introDescription1}<br>
    <br>${ipInfringementForm.introDescription2}<br>
    <br><b>${ipInfringementForm.introText}</b><br>`,
    required: false,
    type: 'paragraph',
  },
  {
    id: 'infringement_type',
    required: true,
    type: 'select',
    options: [ipInfringementForm.type, ipInfringementForm.type1, ipInfringementForm.type2],
  },
  {
    id: 'filer_type',
    required: true,
    type: 'select',
    options: [ipInfringementForm.filerType, ipInfringementForm.filerType1, ipInfringementForm.filerType2],
  },
  `<b>${parseLabelField('businessInfo')}</b>`,
  parseTextField('job_title', 'jobTitle'),
  parseTextField('company_name', 'companyName'),
  parseTextField('company_address', 'address'),
  parseTextField('company_city', 'city'),
  parseTextField('company_state', 'state'),
  parseTextField('company_postal_code', 'postalCode'),
  parseTextField('company_country', 'country'),
  parseTextField('company_telephone', 'telephone'),
  {
    default_text: `
    <b>${ipInfringementForm.tradeMarkInfo}</b><br>
    ${ipInfringementForm.tradeMarkDescription}`,
    required: false,
    type: 'paragraph',
  },
  parseTextField('trademark_info'),
  {
    default_text: `
    <b>${ipInfringementForm.copyRightInfo}</b><br>
    ${ipInfringementForm.copyRightDescription}`,
    required: false,
    type: 'paragraph',
  },
  parseTextField('copyright_info'),
  parseLabelField('locationLabel'),
  parseTextField('location_info'),
  parseLabelField('registration'),
  parseTextField('registration_info'),
  parseLabelField('rights'),
  parseTextField('rights_info'),
  parseLabelField('urlDescription'),
  parseTextField('url_info'),
  {
    default_text: `
    <b>${ipInfringementForm.paymentLabel}</b><br>
    ${ipInfringementForm.paymentDescription}`,
    required: false,
    type: 'paragraph',
  },
  parseTextField('payment_info'),
  parseLabelField('merchantDetails'),
  parseTextField('merchant_info'),
  {
    default_text: `
    <b>${ipInfringementForm.contactLabel}</b>`,
    required: false,
    type: 'paragraph',
  },
  parseTextField('first_name', 'firstName'),
  parseTextField('last_name', 'lastName'),
  parseTextField('email_address', 'email'),
];
